import { HStack, Stack, Text } from '@chakra-ui/react';

import ExpertsColorChangeIcon from '../../admin/ai-agent/experts/ExpertsColorChangeIcon';
import { useAIAgentStore } from './AIAgentStore';
import { useTranslation } from 'react-i18next';

export default function AIAgentPreviewHeader() {
  const { t } = useTranslation();
  const { previewExpert } = useAIAgentStore();

  if (!previewExpert) return null;

  const { name, color } = previewExpert;

  return (
    <Stack
      spacing={3}
      padding={6}
      marginX={-6}
      boxShadow="0px 4px 12px 0px rgba(0, 0, 0, 0.08)"
      clipPath="inset(0px 0px -12px 0px)"
    >
      <HStack spacing={2}>
        <ExpertsColorChangeIcon color={color} />

        <Text fontSize="18px" fontWeight={600} color="baseBlack">
          {name}
        </Text>
      </HStack>

      <Stack
        padding={4}
        backgroundColor="neutral.25"
        border="1px solid"
        borderColor="neutral.100"
        borderRadius="16px"
      >
        <Text fontSize="11px" fontWeight={500} color="neutral.800">
          {t('admin.aiAgent.expertPreviewHeader.descriptionOne')}
        </Text>

        <Text fontSize="11px" fontWeight={500} color="neutral.800">
          {t('admin.aiAgent.expertPreviewHeader.descriptionTwo')}
        </Text>
      </Stack>
    </Stack>
  );
}
